import { render } from "./ExpertStatisticsOutboundPbx.vue?vue&type=template&id=0cda0c6c"
import script from "./ExpertStatisticsOutboundPbx.vue?vue&type=script&lang=js"
export * from "./ExpertStatisticsOutboundPbx.vue?vue&type=script&lang=js"

import "./ExpertStatisticsOutboundPbx.vue?vue&type=style&index=0&id=0cda0c6c&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__